import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { base64Encode } from '@softline/core';
import { SignatureService } from '../services/signature.service';

@Pipe({
  name: 'loadSignature',
  pure: true
})
export class LoadSignaturePipe implements PipeTransform {
  constructor(private service: SignatureService) {}

  transform(value: any, ...args: unknown[]): Observable<any> {
    const data = JSON.stringify(value);
    const encoded = base64Encode(data);
    return this.service.getSignatureImage(encoded);
  }
}
